import { ApiMask, updateApiMask } from '../../../logger/BitMask';
import { Fetcher } from '../../Fetcher';

import { userInfoEndpoint } from './endpoints';
import { UserInfoType } from './types';

export interface FetchUserInfoParams {
  JSESSIONID: string;
  force?: boolean;
  baseUrl: string;
  totalBalance?: boolean;
}

export const fetchUserInfo = ({
  JSESSIONID,
  force,
  baseUrl,
  totalBalance,
}: FetchUserInfoParams): Promise<UserInfoType> => {
  const url = `${baseUrl}${userInfoEndpoint.url}`;
  return Fetcher.fetch(url, {
    force,
    params: {
      JSESSIONID,
    },
    format: 'json',
  }).then((resUserInfo) => {
    updateApiMask(ApiMask.Balance);
    return userInfoEndpoint.parser(resUserInfo, { totalBalance: !!totalBalance });
  });
};
